import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconLockCategory = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M16 2a6 6 0 0 0-6 6v4h12V8a6 6 0 0 0-6-6m8 10V8A8 8 0 1 0 8 8v4H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3V15a3 3 0 0 0-3-3zM6 14a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1zm10 6a1 1 0 0 1 1 1v4.5a1 1 0 1 1-2 0V21a1 1 0 0 1 1-1" clipRule="evenodd" /></svg>;
export default SvgIconLockCategory;